// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'File... Remove this comment to see the full error message
import Dimensions from 'FileManagerLib/components/Dimensions';
import { pixelStepperFormatter, pixelStepperParser } from '../utils/dimensionsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const DimensionsField = ({
  maxHeight = 0,
  defaultHeight = 0,
  imageFieldState,
  setImageFieldState,
  readOnly = false
}) => {
  const {
    disabled,
    height,
    maxWidth,
    naturalHeight,
    naturalWidth,
    width,
    aspectRatio
  } = imageFieldState;
  const handleReset = e => {
    e.preventDefault();
    setImageFieldState(Object.assign({}, imageFieldState, {
      height: defaultHeight,
      maxWidth: Math.round(maxHeight * (aspectRatio || 0)),
      width: Math.round(defaultHeight * (aspectRatio || 0))
    }));
  };
  const handleDimensionChange = ({
    height: updatedHeight,
    width: updatedWidth
  }) => {
    // Because of the rounding dimensions can sometimes result being
    // more than the maximum allowed
    const newHeight = Math.min(updatedHeight, maxHeight);
    const newWidth = Math.min(updatedWidth, maxWidth || 0);
    setImageFieldState(Object.assign({}, imageFieldState, {
      height: newHeight,
      width: newWidth
    }));
  };
  return /*#__PURE__*/_jsx(Dimensions, {
    dimensions: {
      height,
      width
    },
    disabled: disabled || readOnly,
    heightStepperProps: {
      formatter: pixelStepperFormatter,
      max: maxHeight,
      parser: pixelStepperParser,
      styled: true,
      placeholderValue: 0
    },
    naturalHeight: naturalHeight,
    naturalWidth: naturalWidth,
    onChange: handleDimensionChange,
    onReset: handleReset,
    widthStepperProps: {
      formatter: pixelStepperFormatter,
      max: maxWidth,
      parser: pixelStepperParser,
      styled: true,
      placeholderValue: 0
    },
    withResetButton: true
  });
};
export default DimensionsField;